import { deriveFunnelView, type FunnelStepView } from '@/entities/dropper-funnel';
import type { IClientEvent } from '@/entities/client-event.entity';
import { cn } from '@/lib/utils';
import { CheckIcon, CircleDashedIcon, XIcon } from 'lucide-react';
import { useMemo } from 'react';

interface ClientFunnelPipelineCardProps {
	events: IClientEvent[];
}

function StepIcon({ state }: { state: FunnelStepView['state'] }) {
	if (state === 'done') return <CheckIcon size={14} className='text-chart-2' />;
	if (state === 'failed') return <XIcon size={14} className='text-destructive' />;
	return <CircleDashedIcon size={14} className='text-muted-foreground' />;
}

export default function ClientFunnelPipelineCard({ events }: ClientFunnelPipelineCardProps) {
	const steps = useMemo(() => deriveFunnelView(events), [events]);
	const doneCount = steps.filter(s => s.state === 'done').length;

	return (
		<div className='rounded-md border border-border bg-card px-3 py-2 grid gap-2'>
			<div className='flex items-center justify-between gap-2'>
				<span className='text-sm font-medium'>Воронка установки</span>
				<span className='text-xs text-muted-foreground'>{doneCount}/{steps.length}</span>
			</div>
			<div className='grid gap-1'>
				{steps.map(step => (
					<div key={step.name} className='flex items-center gap-2 min-w-0'>
						<StepIcon state={step.state} />
						<span
							className={cn(
								'text-xs truncate',
								step.state === 'done' && 'text-foreground',
								step.state === 'failed' && 'text-destructive',
								step.state === 'pending' && 'text-muted-foreground',
							)}
						>
							{step.label}
						</span>
					</div>
				))}
			</div>
		</div>
	);
}
